import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import { SimplifiedRegistryEntry, Skin } from 'lib/vendor/terrific/Application';

import SDXModalDialog from 'lib/generic/SDXModalDialog';

import { pageSegment, Segment } from 'lib/ecommerce/util';

import {
	getDefaultReturnUrl,
	stringifyParams,
	getInOneHomeProducts,
	Params,
	Product,
	ProductType,
} from './helpers';

import { CurrentSelection } from 'lib/ecommerce/lego/Tc.Module.LegoContainer';

const AJAX_TYPE_GET = 'GET';
const AJAX_DATA_TYPE_JSON = 'json';

class LeadManagement extends Module {
	public readonly baseUrl = [
		window.location.protocol,
		'//',
		window.location.host,
	].join('');
	public readonly segment : 'RES' | 'SME' = (pageSegment() || Segment.RES).toUpperCase() as 'RES' | 'SME';

	private $link! : JQuery;

	public on(callback : Hook) {
		this.$link = this.$ctx.find('a');

		/*
		 * Because there is an open parsys where editors can add
		 * typography component that themselves may contain anchor tags,
		 * we must only wrapp the parsys content when we can not find any anchor tag already.
		*/
		if(!this.$link.length) {
			const anchor = $('<a></a>', {href: ''});
			anchor.append(this.$ctx.children());
			this.$ctx.append(anchor);
			this.$link = anchor;
		}

		this.$link.on('click', event => {
			event.preventDefault();
			event.stopImmediatePropagation();
			if (!this.$ctx.is('.disabled')) {
				this.$ctx.addClass('disabled');
				this.validateDeeplink();
			}
		});

		callback();
	}

	public updateLink(params : Params) {
		const url = stringifyParams(params, this.baseUrl);
		this.$ctx.toggleClass('disabled', !url);
		this.$link.prop('href', url || '#');
	}

	protected validateDeeplink() : void {
		const url = this.$link.attr('href')!;
		const serviceApi = `/lmneo/guest/services/anon/validate/deeplink?url=${encodeURIComponent(url)}`;

		$.ajax({
			dataType: AJAX_DATA_TYPE_JSON,
			type: AJAX_TYPE_GET,
			url: serviceApi,
		}).then(
			(data : AjaxValidationResponse) => {
				if (data.valid) {
					window.location.href = this.$link.attr('href')!;
				} else {
					this.onValidationError(data.failureMessages[0]);
				}
			},
			error => {
				this.onValidationError(error.responseText);
			},
		);
	}

	private onValidationError(message : string) {
		SDXModalDialog.show({
			buttons: [{
				thin: true,
				title: this.$ctx.data('close-label'),
				type: 'close',
			}],
			notification: 'alert',
			text: message,
		});
	}
}

interface AjaxValidationResponse {
	failureMessages : string[];
	valid : boolean;
}

interface LegoConfig {
	currentSelection : CurrentSelection;
	deeplinkHashParameters : string;
	prices : LegoPrices;
	productIds : LegoProduct[];
}

interface LegoProduct {
	siebelId : string;
	priceDifference : number;
}

interface LegoPrices {
	bundleBasePrice : number;
	homePrice : number;
	mobilePrice : number;
	totalPrice : number;
}

interface LegoContainerSkin extends LeadManagement {
	onNewLegoConfiguration(data : LegoConfig) : void;
}

interface ManualSkin extends LeadManagement {
}

// tslint:disable-next-line:variable-name
const LegoContainer : Skin<LeadManagement, LegoContainerSkin> = function() {
	this.after = function() {
		this.sandbox.subscribe('LEGO_CONTAINER', this);
	};

	this.onNewLegoConfiguration = function(data : LegoConfig) {
		let nestedParams : Params | null = null;

		if (
			data.currentSelection.mobile &&
			data.currentSelection.mobile.slideId &&
			data.currentSelection.mobile.slideId !== 'N_LEGO No Mobile'
		) {
			// We need a nested lead url inside return url
			nestedParams = {
				cancelUrl: window.location.href,
				leadProductGroup: 'WIRELESS',
				mode: '4P_Wireless',
				productInfo: [
					{ type: ProductType.Bundle, value: data.currentSelection.mobile.slideId },
					{ type: ProductType.AboLength, value: '12' },
				],
				productSegment: this.segment,
				returnUrl: getDefaultReturnUrl(this.baseUrl),
			};
		}

		let inOneHomeProducts : Product[] = [
			{ type: ProductType.Bundle, value : (this.segment === Segment.RES.toUpperCase()) ? 'LEGO Home' : 'LEGO Pro' },
		];

		inOneHomeProducts = inOneHomeProducts.concat(getInOneHomeProducts(data.currentSelection));
		const params : Params = {
			cancelUrl: window.location.href,
			leadProductGroup: 'WIRELINE',
			mode: nestedParams ? '4P_Wireline' : undefined,
			productInfo: inOneHomeProducts,
			productSegment: this.$ctx.data('productSegment') || this.segment,
			returnUrl: nestedParams || getDefaultReturnUrl(this.baseUrl),
		};

		this.updateLink(params);
	};
};

// tslint:disable-next-line:variable-name
const Manual : Skin<LeadManagement, ManualSkin> = function() {

	this.after = function() {
		const cancelUrl = new URL(this.$ctx.data('cancelUrl') || window.location.href, this.baseUrl);
		const returnUrl = new URL(this.$ctx.data('returnUrl') || getDefaultReturnUrl(this.baseUrl), this.baseUrl);

		const params = {
			cancelUrl: cancelUrl.href,
			leadProductGroup: this.$ctx.data('leadProductGroup') || 'WIRELINE',
			productInfo: this.$ctx.data('productInfo'),
			productSegment: this.$ctx.data('productSegment') || this.segment.toUpperCase(),
			returnUrl: returnUrl.href,
		};

		this.updateLink(params);
	};
};

const registryEntry : SimplifiedRegistryEntry = {
	module: LeadManagement,
	skins: {
		LegoContainer,
		Manual,
	},
};

export default registryEntry;




// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/generic/leadmanagement/Tc.Module.LeadManagement.ts